module.exports = __webpack_public_path__ + "img/activity_apply.3035cf13.png";